<template>
  <q-btn :disable="disabled" :label="time" @click="showClock = true">
    <q-popup-proxy ref="clock" transition-hide="scale" transition-show="scale" @hide="showClock = false">
      <div class="column">
        <q-time v-model="timeInput" landscape mask="h:mm A" @input="$emit('input', $event)" />
      </div>
    </q-popup-proxy>
  </q-btn>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      value: false,
    },
    time: String,
  },
  data() {
    return {
      timeInput: null,
    };
  },
  mounted() {
    this.timeInput = this.time;
  },
};
</script>
